import { render, staticRenderFns } from "./step-resume.vue?vue&type=template&id=1f47519e"
import script from "./step-resume.vue?vue&type=script&lang=js"
export * from "./step-resume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports